import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "../../services/baseQuery";
import { buildPagedListUrl } from "../../services/queryParams";

export const oemApi = createApi({
  reducerPath: "oemApi",
  baseQuery: appBaseQuery,
  tagTypes: ["OEM"],
  endpoints: (builder) => ({
    getOems: builder.query({
      query: (params = {}) => buildPagedListUrl("oem/", params),
      providesTags: ["OEM"],
    }),
    addOem: builder.mutation({
      query: (newOem) => ({
        url: "oem/",
        method: "POST",
        body: newOem,
      }),
      invalidatesTags: ["OEM"],
    }),
    updateOem: builder.mutation({
      query: ({ uid, ...updatedOem }) => ({
        url: `oem/${uid}`,
        method: "PUT",
        body: updatedOem,
      }),
      invalidatesTags: ["OEM"],
    }),
    deleteOem: builder.mutation({
      query: (uid) => ({
        url: `oem/${uid}`,
        method: "DELETE",
      }),
      invalidatesTags: ["OEM"],
    }),
  }),
});

export const {
  useGetOemsQuery,
  useLazyGetOemsQuery,
  useAddOemMutation,
  useUpdateOemMutation,
  useDeleteOemMutation,
} = oemApi;
